export const CONTEXT_PATH = '/hu';

// Native <-> WebView 인터페이스 코드 정의
export const WEBVIEW = {
  // WebView -> Native
  SEND_CODE: {
    GO_BACK: '200', // 웹의 뒤로가기 클릭
    AI_CHAT: '201', // AI 에이전트 조언 응답
    AI_CHAT_TEST: '999', // AI_CHAT_TEST
  },
  // Natvie -> WebView
  RECEIVE_CODE: {
    AUTHORIZATION: '100', // 토큰 정보
    AI_CHAT: '101', // AI 에이전트 조언 요청
    AI_CHAT_TEST: '999', // AI_CHAT_TEST
  },
};
